import { AppSecureContainer } from "./components/AppSecureContainer";

export default AppSecureContainer;